import React from 'react';
import Sidemenu from './components/sidemenu/Sidemenu.jsx'; // Path to your sidebar component
import Navbar from './components/navbar/Navbar.jsx';   // Path to your navbar component
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <div>
        <Navbar />
        <div className="App">
            <Sidemenu />
            <div className="content">
                <Outlet/>
            </div>
        </div>
        
    </div>
  );
};

export default Layout;
